import script from "./storeIdNoticeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./storeIdNoticeModal.vue?vue&type=script&setup=true&lang=js"

import "./storeIdNoticeModal.vue?vue&type=style&index=0&id=37672b90&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37672b90"]])

export default __exports__